import CryptoJS from 'crypto-js';

export default function deCrytageData(userData) {
  const key = 'secret key 123';
  if (userData) {
    const bytes = CryptoJS.AES.decrypt(userData.toString(), key);
    const plaintext = bytes.toString(CryptoJS.enc.Utf8);
    return plaintext;
  }
  return null;
}
